import config from "../../../config";
import useFetchSettlement from "../../../hooks/useFetchSettlement";
import React, { useState, useEffect, useCallback } from "react";
import { Container, Fab, makeStyles } from "@material-ui/core";
import ContentLoader from "../../ContentLoader/ContentLoader";
import ListSettlements from "../../ListSettlements/ListSettlements";

export default function Settlements(props) {
  const { authKey, idDriver } = props;

  const url = `${config.API_URL}services/app/Trip/GetTripsWithOutSettlementByDriver?idDriver=${idDriver}&key=${authKey}`

  const { isLoading, settlements, error } = useFetchSettlement(url);
  console.log(settlements);
  return (
    <Container
      style={{
        position: "fixed",
        height: "100%",
        paddingLeft: "0px",
        paddingRight: "0px",
      }}
    >
      {isLoading ? <ContentLoader /> : <ListSettlements settlements={settlements} />}
    </Container>
  );
}
